import React, {useState} from 'react'
import format from "date-fns/format";

const PersonalItem = ({oneStaff}) => {

    const [active, setActive] = useState(false);
    const handleCollapse = () => {
        setActive(!active);
    }

  return (
    <div className="div-staffs" onClick={handleCollapse}>
      <span key={oneStaff.id}>
        <i className="bi bi-person">
          <strong>{oneStaff.name}</strong> CC.{" "}
          <strong>{oneStaff.identification}</strong>
        </i>
      </span>
      <br></br>
      {active && (
        <div>
          <span>
            <i className="bi bi-calendar">
              {` Fecha de nacimiento:`}{" "}
              {
                <strong>
                  {format(new Date(oneStaff.birthDate), "MM/dd/yyyy")}
                </strong>
              }
            </i>
          </span>
          <br></br>
          <span>
            <i className="bi bi-calendar">
              {` Fecha de expedicion:`}{" "}
              {
                <strong>
                  {format(new Date(oneStaff.expeditionDate), "MM/dd/yyyy")}
                </strong>
              }
            </i>
          </span>
          <br></br>
          <span>
            <i className="bi bi-heart-pulse">
              {` ARL: `}
              {<strong>{oneStaff.riskEntityName}</strong>}
            </i>
          </span>
          <hr />
        </div>
      )}
    </div>
  );
}

export default PersonalItem